import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import * as terapiaService from "../../services/terapiaService";
import { Grid, Card, CardContent, Snackbar, Alert } from '@mui/material';
import Therapy from '../../components/Therapy'
import TherapySchedule from '../../components/TherapySchedule'
import TherapyTherapist from '../../components/TherapyTherapist'
import TherapyMember from '../../components/TherapyMember'
import MantenimientoForm from '../../components/common/MantenimientoForm';
import { useMantenimiento } from '../../hooks/useMantenimiento';
import { activeValidations as activeValidationsTherapy } from '../../redux/therapySlice';
import { setEntity as setTherapySchedule, activeValidations as activeTherapySchedule } from '../../redux/therapyScheduleSlice';
import { setEntity as setTherapyTherapist, activeValidations as activeTherapyTherapist } from '../../redux/therapyTherapistSlice';
import { setEntity as setTherapyMember, activeValidations as activeTherapyMember } from '../../redux/therapyMemberSlice';

const Edit = (props) => {
   const therapy = useSelector((state) => state.therapy.entity);
   const therapySchedule = useSelector((state) => state.therapySchedule.entity);
   const therapyTherapist = useSelector((state) => state.therapyTherapist.entity);
   const therapyMember = useSelector((state) => state.therapyMember.entity);
   const therapyValidation = useSelector((state) => state.therapy.validationMessage);
   const therapyScheduleValidation = useSelector((state) => state.therapySchedule.validationMessage);
   const therapyTherapistValidation = useSelector((state) => state.therapyTherapist.validationMessage);
   const therapyMemberValidation = useSelector((state) => state.therapyMember.validationMessage);

   const defaultTherapySchedule = useSelector((state) => state.therapySchedule.defaultEntity)
   const defaultTherapyTherapist = useSelector((state) => state.therapyTherapist.defaultEntity)
   const defaultTherapyMember = useSelector((state) => state.therapyMember.defaultEntity)
  const [openMessage, setOpenMessage] = useState(false)
  const onCloseMessage = () => { setOpenMessage(!openMessage); }
  const [propsMessage, setPropsMessage] = useState({ severity: "success", message: "" });
  const dispatch = useDispatch();
  const params = useParams();
  const { isReadOnly, setIsReadOnly } = useMantenimiento("terapia");
  const postEntity = async () => {
    var dataPost = {
      ...therapy
      , terapiaHorario: therapySchedule, terapiaTerapeuta: therapyTherapist, terapiaParticipante: therapyMember
    }

    var ValidationMessages = therapyValidation.concat(therapyMemberValidation).concat(therapyScheduleValidation).concat(therapyTherapistValidation)

    console.log(dataPost)
    console.log(ValidationMessages)

    if (ValidationMessages.length > 0) {
      dispatch(activeValidationsTherapy());
      dispatch(activeTherapySchedule());
      dispatch(activeTherapyTherapist());
      dispatch(activeTherapyMember());

      setPropsMessage({ severity: "error", message: ValidationMessages.join(" - ") })
      setOpenMessage(true);
    }
    else {
      await terapiaService.addUpdateTherapyWithDetails(dataPost)
        .then(response => {
          setPropsMessage({ severity: "success", message: "Se guardaron los datos con exito" })
          setOpenMessage(true);
          setIsReadOnly(true);

          if (therapy.id > 0){
            terapiaService.getsTerapiaHorarioView(therapy.id)
            .then(data => {
              if (data === null || data.length === 0)
                dispatch(setTherapySchedule(defaultTherapySchedule));
              else
                dispatch(setTherapySchedule(data));
            })
            .catch((err) => {
              console.log("Err: ", err);
            });

            terapiaService.getsTerapiaTerapeutaView(therapy.id)
            .then(data => {
              if (data === null || data.length === 0)
                dispatch(setTherapyTherapist(defaultTherapyTherapist));
              else
                dispatch(setTherapyTherapist(data));
            })
            .catch((err) => {
              console.log("Err: ", err);
            });

            terapiaService.getsTerapiaParticipanteView(therapy.id)
            .then(data => {
              if (data === null || data.length === 0)
                dispatch(setTherapyMember(defaultTherapyMember));
              else
                dispatch(setTherapyMember(data));
            })
            .catch((err) => {
              console.log("Err: ", err);
            });
          }
        })
        .catch(error => {
          setPropsMessage({ severity: "error", message: "Hubo un error" })
          setOpenMessage(true);
        });
    }
  }

  return (
    <div>
      <MantenimientoForm
        title={(params.id == 0 ? "Nueva" : "Editar") + " Terapia"}
        backTo={"/therapy"}
        onSave={postEntity}
        disabled={isReadOnly}
      >
        <Grid container spacing={1} sx={{
          "& .MuiGrid-root>.MuiGrid-item": {
            paddingTop: "8px"
          },
        }}>
          <Grid item xs={12} sm={12}>
            <Card >
              <CardContent sx={{ padding: "0px 10px 10px 10px !important" }}>
                <Therapy isReadOnly={isReadOnly} />
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={12}>
            <Card>
              <CardContent sx={{ padding: "0px 10px 10px 10px !important" }}>
                <TherapyTherapist isReadOnly={isReadOnly} />
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Card>
              <CardContent sx={{ padding: "0px 10px 10px 10px !important" }}>
                <TherapyMember isReadOnly={isReadOnly} />
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Card>
              <CardContent sx={{ padding: "0px 10px 10px 10px !important" }}>
                <TherapySchedule isReadOnly={isReadOnly} />
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </MantenimientoForm>
      <Snackbar open={openMessage} autoHideDuration={5000} onClose={onCloseMessage}
        anchorOrigin={{vertical: "top", horizontal: "center"}}>
        <Alert onClose={onCloseMessage} severity={propsMessage.severity}>
          {propsMessage.message}
        </Alert>
      </Snackbar>
    </div>
  )
}

export default Edit
